import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  field: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "& [role='button']": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      maxHeight: "60px",
      ...shorthands.padding("18px", "18px"),
      ...shorthands.gap("6px"),
      backgroundColor: tokens.colorNeutralBackground3,
      "& > *": {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
      },
    },
    "& > *": {
      width: "100%",
    },
  },
  labelText: {
    flexGrow: 0,
    flexShrink: 0,
  },
  labelRight: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flexShrink: 0,
    marginLeft: "auto",
    ...shorthands.gap("6px"),
  },
  labelError: {
    color: tokens.colorPaletteRedBackground3,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase100,
    justifyContent: "center",
    ...shorthands.flex(1),
  },
  maximum: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase300,
  },
  option: {
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
    width: "100%",
    ...shorthands.padding("9px", "18px"),
    ...shorthands.borderBottom("1px", "solid", tokens.colorNeutralBackground3),
    "& .fui-Checkbox__input": {
      left: "18px",
    },
    "& .fui-Radio__input": {
      left: "18px",
    },
    ": last-child": {
      borderBottom: "none",
    },
  },
  validation: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase300,
  },
  checked: {
    backgroundColor: tokens.colorPalettePurpleBackground2,
    color: "#242424",
  },
  text: {
    color: "#242424",
  },
});
